const setCookie = (name, value) => {
  document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; max-age=31536000"
}

const getCookie = (name) => {
  const cookies = document.cookie ? document.cookie.split("; ") : []
  for (let cookie of cookies) {
    const [key, ...valueParts] = cookie.split("=")
    if (key.trim() === name) {
      return decodeURIComponent(valueParts.join("="))
    }
  }
  return null
}


export const CusCookie = {
  setCookie,
  getCookie
}